import React from 'react';
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'
import moment from 'moment/min/moment-with-locales';
import InfiniteScroll from 'react-infinite-scroller';
import LoadingGif from '../../../lib/images/loading.gif';
import { Link } from 'react-router-dom';
import defaultUserThumb from '../../../lib/images/user-thumb-default.png'
import * as RT from '../../../constants/Routing'

moment.locale('ja')

export default class Component extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      readIds: []
    }
  }

  componentWillMount = () => {
    this.props.notificationGet(this.state.page)
  }

  componentWillUnmount = () => {
    this.props.notificationRead(this.state.readIds.join(','))
  }

  fetchNextPage = () => {
    const noticeArea = document.getElementById('notificationList')
    const noticeAreaHeight = noticeArea.scrollHeight
    const windowHeight = window.innerHeight;
    let hasMore = false, currentPage = 1, totalPage = 1
    if (this.props.App.notifications) {
      currentPage = this.props.App.notifications.page
      totalPage = this.props.App.notifications.total_page
      hasMore = currentPage < totalPage
    }

    if (windowHeight > noticeAreaHeight && hasMore) {
      this.props.notificationGet(currentPage + 1)
    }
  }

  componentDidMount = () => {
    // this.fetchNextPage()
  }

  componentDidUpdate = () => {
    this.fetchNextPage()
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.App.notifications !== nextProps.App.notifications) {
      const readIds = nextProps.App.notifications.notifications.map(notice => { return notice.id })
      this.setState({ readIds: readIds })
    }
  }

  render = () => {
    const metaInfo = (
      <Helmet>
        <title>お知らせ | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)のお知らせページです。あなたへのお知らせが確認できます。' />
      </Helmet>
    )

    let notificationBody, notifications, hasMore = false, currentPage = 1, totalPage, nextPage

    if (this.props.App.notifications) {
      notifications = this.props.App.notifications.notifications
      totalPage = this.props.App.notifications.total_page
      currentPage = this.props.App.notifications.page
      hasMore = totalPage > currentPage
    }
    
    nextPage = currentPage + 1
    if (notifications.length > 0) {
      const listItems = notifications.map(notice => {
        const target_id = notice.target_id
        const link_id = notice.link_id
        if (target_id && link_id) {

        }
        let photo = defaultUserThumb
        if (notice.icon) {
          photo = notice.icon
        }

        let isLink = false, targetUrl
        switch (notice.type) {
          case 'apply':
            targetUrl = RT.COMMUNITY_MANAGE_PATH.replace(/:id/, notice.target_id)
            isLink = true
            break;
          case 'chat':
            targetUrl = RT.MESSAGE_ROOM_PATH.replace(/:id/, notice.link_to)
            isLink = true
            break;
          case 'approve':
            targetUrl = RT.COMMUNITY_PATH.replace(/:id/, notice.link_to)
            isLink = true
            break;
          case 'topic':
            targetUrl = RT.COMMUNITY_POSTS_PATH.replace(/:id/, notice.link_to)
            isLink = true
            break
          case 'comment':
            targetUrl = RT.COMMUNITY_POSTS_PATH.replace(/:id/, notice.link_to)
            isLink = true
            break
          default:
            break;
        }
        if (isLink) {
          return (
            <li key={notice.id} className={'notificationItem' + (notice.unread ? ' unread' : '')}>
              <Link to={targetUrl}>
                <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
                <span>{notice.content}</span>
                <span className='noticeDate'>{moment(notice.notified_at).fromNow()}</span>
              </Link>
            </li>
          )
        } else {
          return (
            <li key={notice.id} className={'notificationItem' + (notice.unread ? ' unread' : '')}>
              <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
              <span>{notice.content}</span>
              <span className='noticeDate'>{moment(notice.notified_at).fromNow()}</span>
            </li>
          )
        }
      })
      notificationBody = (
        <InfiniteScroll
          pageStart={1}
          loadMore={() => { this.props.notificationGet(nextPage) }}
          hasMore={hasMore}
          loader={<img key={0} src={LoadingGif} alt='' className='loading-img small' />}
          initialLoad={false}
          useWindow={true}
        >
          <ul id='notificationList'>
            {listItems}
          </ul>
        </InfiniteScroll>
      )
    } else {
      notificationBody = (
        <ul id='notificationList' className='noItem'>
          <li className='notificationItem'>お知らせはありません。</li>
        </ul>
      )
    }

    return (
      <div className='container notificationWrap'>
        {metaInfo}
        <h3 className='headline mb-4'>お知らせ</h3>
        {notificationBody}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/User/Notification/Notification.jsx